<template>
  <v-card class="shadowCard tarjeta-bono" :class="claseEstado">
    <v-progress-linear v-if="cargando" indeterminate color="teal" height="3" />
    <v-card-text class="pa-5">
      <div class="bono-top">
        <div class="bono-identidad">
          <v-avatar size="46" :color="alcanzado ? 'amber lighten-4' : 'teal lighten-5'">
            <v-icon :color="alcanzado ? 'amber darken-3' : 'teal darken-2'">
              {{ alcanzado ? 'mdi-trophy' : 'mdi-account-reactivate' }}
            </v-icon>
          </v-avatar>
          <div class="ml-3">
            <div class="bono-kicker">{{ kicker }}</div>
            <div class="bono-nombre">{{ tituloPlantel }}</div>
            <div class="bono-rango">{{ rangoTexto }}</div>
          </div>
        </div>
        <div class="bono-premio">
          <div class="bono-premio-label">{{ alcanzado ? '¡Bono ganado!' : 'Premio' }}</div>
          <div class="bono-premio-monto" :class="claseMonto">{{ bonoFormato }}</div>
        </div>
      </div>

      <v-row dense class="mt-4">
        <v-col cols="6" sm="3">
          <div class="stat">
            <div class="stat-label">Objetivo</div>
            <div class="stat-valor">{{ objetivo }}</div>
            <div class="stat-hint">{{ metaPct }}% de reinscribibles</div>
          </div>
        </v-col>
        <v-col cols="6" sm="3">
          <div class="stat stat--ok">
            <div class="stat-label">Semana 2</div>
            <div class="stat-valor">{{ lleva }}</div>
            <div class="stat-hint">{{ pct }}% de avance</div>
          </div>
        </v-col>
        <v-col cols="6" sm="3">
          <div class="stat" :class="faltan > 0 ? 'stat--falta' : 'stat--ok'">
            <div class="stat-label">Faltan</div>
            <div class="stat-valor">{{ faltan }}</div>
            <div class="stat-hint">{{ faltan === 1 ? 'alumno' : 'alumnos' }}</div>
          </div>
        </v-col>
        <v-col cols="6" sm="3">
          <div class="stat" :class="alcanzado ? 'stat--bono-ganado' : 'stat--bono-falta'">
            <div class="stat-label">Bono</div>
            <div class="stat-valor stat-valor--bono" :class="claseMonto">{{ bonoFormato }}</div>
            <div class="stat-hint">{{ alcanzado ? 'meta alcanzada' : 'si llega a la meta' }}</div>
          </div>
        </v-col>
      </v-row>

      <div class="mt-4">
        <div class="d-flex justify-space-between mb-1">
          <span class="avance-texto">{{ lleva }} de {{ objetivo }}</span>
          <span class="avance-texto">{{ pct }}%</span>
        </div>
        <v-progress-linear
          :value="pctBarra"
          height="12"
          rounded
          :color="colorBarra"
        />
      </div>

      <div class="motivacion mt-4" :class="claseMotivacion">
        <v-icon class="mr-2" :color="colorMotivacion">{{ iconoMotivacion }}</v-icon>
        <span>{{ mensajeMotivacion }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { filasBonoRiDelUsuario } from '@/utils/bonoRiAsignacion'

export default {
  name: 'TarjetaMiBonoRI',

  props: {
    fila: { type: Object, default: null },
    filas: { type: Array, default: () => [] },
    resumen: { type: Object, default: () => ({}) },
    cicloAct: { type: Object, default: null },
    cicloSig: { type: Object, default: null },
    fecha_corte: { type: String, default: '' },
    cargando: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    nombre() {
      return (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.nombre_completo) || 'Usuario'
    },
    misFilas() {
      return filasBonoRiDelUsuario(this.filas, this.getdatosUsuarioERPERP)
    },
    esPersonal() {
      return this.misFilas.length > 0
    },
    datos() {
      if (this.fila) {
        const f = this.fila
        return {
          plantel: f.plantel || '',
          reinscribibles: Number(f.reinscribibles) || 0,
          objetivo: Number(f.objetivo) || 0,
          lleva: Number(f.lleva_s2 != null ? f.lleva_s2 : f.lleva) || 0,
          bono: Number(f.bono_personal) || 0,
          meta: Number(f.meta) || 75,
        }
      }
      if (this.esPersonal) {
        const vistos = {}
        let reinscribibles = 0
        let objetivo = 0
        let lleva = 0
        let bono = 0
        let meta = 75
        let plantel = ''
        this.misFilas.forEach((f) => {
          bono += Number(f.bono_personal) || 0
          const idp = Number(f.id_plantel)
          if (vistos[idp]) return
          vistos[idp] = true
          reinscribibles += Number(f.reinscribibles) || 0
          objetivo += Number(f.objetivo) || 0
          lleva += Number(f.lleva_s2) || 0
          meta = Number(f.meta) || meta
          plantel = plantel ? 'Varios planteles' : (f.plantel || '')
        })
        if (Object.keys(vistos).length > 1) plantel = 'Varios planteles'
        return { plantel, reinscribibles, objetivo, lleva, bono, meta }
      }
      const r = this.resumen || {}
      return {
        plantel: '',
        reinscribibles: Number(r.reinscribibles) || 0,
        objetivo: Number(r.objetivo) || 0,
        lleva: Number(r.lleva) || 0,
        bono: Number(r.bono) || 0,
        meta: 75,
      }
    },
    kicker() {
      return this.esPersonal || this.fila ? 'Mi bono de RI' : 'Bono de RI de la escuela'
    },
    tituloPlantel() {
      return this.datos.plantel || this.nombre
    },
    objetivo() { return this.datos.objetivo },
    lleva() { return this.datos.lleva },
    faltan() { return Math.max(0, this.objetivo - this.lleva) },
    metaPct() { return this.datos.meta || 75 },
    alcanzado() { return this.objetivo > 0 && this.lleva >= this.objetivo },
    pct() {
      const base = this.datos.reinscribibles
      if (!base) return 0
      return Math.round((this.lleva * 100) / base)
    },
    pctBarra() {
      if (!this.objetivo) return 0
      return Math.min(100, Math.round((this.lleva * 100) / this.objetivo))
    },
    bonoFormato() {
      return Number(this.datos.bono || 0).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        maximumFractionDigits: 0,
      })
    },
    rangoTexto() {
      const persona = this.datos.plantel ? this.nombre : ''
      const act = this.cicloAct && this.cicloAct.ciclo
      const sig = this.cicloSig && this.cicloSig.ciclo
      const ciclo = (act && sig) ? `${act} → ${sig}` : 'RI a semana 2'
      const partes = [persona, ciclo].filter(Boolean)
      return partes.join(' · ')
    },
    mensajeMotivacion() {
      const plantel = this.datos.plantel
      const donde = plantel ? ` en ${plantel}` : ''
      if (!this.objetivo) {
        return 'Aún no hay objetivo de RI. En cuanto cargue el avance, aquí ves la meta.'
      }
      if (this.alcanzado) {
        return `¡Lo lograron${donde}! Ya se alcanzó el ${this.metaPct}% de RI a semana 2.`
      }
      if (this.faltan === 1) {
        return `Falta 1 alumno${donde} para la meta de semana 2.`
      }
      return `Faltan ${this.faltan} alumnos${donde} para el ${this.metaPct}% de RI a semana 2.`
    },
    claseMonto() {
      if (this.alcanzado) return 'monto--dorado'
      if (this.objetivo > 0) return 'monto--rojo'
      return 'monto--neutro'
    },
    claseEstado() {
      if (this.alcanzado) return 'tarjeta-bono--ganado'
      if (this.objetivo > 0) return 'tarjeta-bono--pendiente'
      return ''
    },
    colorBarra() {
      if (this.alcanzado) return 'amber darken-2'
      if (this.pctBarra >= 75) return 'teal darken-1'
      if (this.pctBarra >= 40) return 'light-green darken-1'
      return 'blue-grey lighten-1'
    },
    iconoMotivacion() {
      return this.alcanzado ? 'mdi-trophy' : 'mdi-fire'
    },
    colorMotivacion() {
      if (this.alcanzado) return 'amber darken-3'
      if (this.objetivo > 0) return 'red darken-3'
      return 'blue-grey'
    },
    claseMotivacion() {
      if (this.alcanzado) return 'motivacion--ganado'
      if (this.objetivo > 0) return 'motivacion--falta'
      return ''
    },
  },
}
</script>

<style scoped>
.tarjeta-bono {
  background: linear-gradient(180deg, #ffffff 0%, #f7fffb 100%) !important;
  border: 1px solid #d8efe4;
  border-radius: 16px !important;
}

.tarjeta-bono--pendiente {
  background: linear-gradient(180deg, #fff5f5 0%, #ffebee 100%) !important;
  border-color: #ef9a9a;
}

.tarjeta-bono--ganado {
  background: linear-gradient(180deg, #fff8e1 0%, #fffde7 100%) !important;
  border-color: #ffe082;
}

.bono-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.bono-identidad {
  display: flex;
  align-items: center;
  min-width: 0;
}

.bono-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #00695c;
}

.bono-nombre {
  font-size: 1.25rem;
  font-weight: 800;
  color: #1b2a2f;
  line-height: 1.2;
}

.bono-rango {
  font-size: 12px;
  color: #78909c;
  margin-top: 2px;
}

.bono-premio {
  text-align: right;
}

.bono-premio-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8d6e63;
}

.bono-premio-monto {
  font-size: 3.6rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -1.5px;
}

.stat-valor--bono {
  font-size: 2.45rem;
  letter-spacing: -0.5px;
}

.monto--rojo { color: #c62828 !important; }
.monto--dorado {
  color: #c9a227 !important;
  text-shadow: 0 1px 0 #fff8e1, 0 0 18px rgba(255, 193, 7, 0.45);
}
.monto--neutro { color: #78909c !important; }

.stat--bono-falta {
  background: #ffcdd2;
  border-color: #e53935;
}

.stat--bono-ganado {
  background: linear-gradient(180deg, #fff8e1 0%, #ffecb3 100%);
  border-color: #ffd54f;
}

.stat {
  background: #f7f8fc;
  border: 1px solid #eef0f6;
  border-radius: 12px;
  padding: 12px 8px;
  text-align: center;
  min-height: 92px;
}

.stat--ok {
  background: #e8f5e9;
  border-color: #c8e6c9;
}

.stat--falta {
  background: #fff3e0;
  border-color: #ffe0b2;
}

.stat-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #607d8b;
}

.stat-valor {
  margin-top: 4px;
  font-size: 1.8rem;
  font-weight: 800;
  line-height: 1.1;
  color: #1a237e;
}

.stat-hint {
  margin-top: 2px;
  font-size: 11px;
  color: #90a4ae;
}

.avance-texto {
  font-size: 12px;
  font-weight: 700;
  color: #546e7a;
}

.motivacion {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #eceff1;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 700;
  color: #546e7a;
}

.motivacion--falta {
  background: #ffcdd2;
  color: #b71c1c;
}

.motivacion--ganado {
  background: #fff8e1;
  color: #f57f17;
}
</style>
